import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import CKEditor from 'ckeditor4-react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { noop } from 'Helpers/PropTypes';

CKEditor.editorUrl = '/ckeditor/ckeditor.js';

const config = ({
  minHeight,
  maxHeight,
  placeholder,
  customConfig,
}) => ({
  toolbarGroups: [],
  pasteFromWordRemoveFontStyles: true,
  pasteFromWordRemoveStyles: true,
  allowedContent: true,
  height: minHeight,
  removeDialogTabs: 'link:advanced',
  disableNativeSpellChecker: false,
  toolbarCanCollapse: false,
  resize_enabled: false,
  extraPlugins: 'autogrow,editorplaceholder',
  autoGrow_minHeight: minHeight,
  autoGrow_maxHeight: maxHeight,
  contentsCss: '/ckeditor.css',
  editorplaceholder: placeholder,
  editorplaceholder_delay: 250,
  throttle: 150,
  ...customConfig,
});

const useStyles = makeStyles(() => ({
  root: {
    minHeight: ({ minHeight }) => `${minHeight}px`,
    maxHeight: ({ maxHeight }) => `${maxHeight}px`,
    '& .cke': {
      minHeight: ({ minHeight }) => `${minHeight}px`,
      maxHeight: ({ maxHeight }) => `${maxHeight}px`,
      border: 'none',
      '& > .cke_inner': {
        backgroundColor: 'rgba(0,0,0,0)',
        '& > .cke_top': {
          display: 'none',
        },
        '& > .cke_bottom': {
          display: 'none',
        },
        '& > .cke_contents': {
          '& .cke_wysiwyg_frame': {
            backgroundColor: 'rgba(0,0,0,0)',
          },
        },
      },
    },
  },
}), { name: 'BaseRichTextInput' });

const BaseRichTextInput = React.forwardRef((props, ref) => {
  const {
    onChange,
    value,
    test,
    disabled,
    onLoaded,
  } = props;
  const classes = useStyles(props);

  const handleChange = (e) => {
    onChange(e.editor.getData());
  };

  return (
    <Box className={classes.root}>
      <CKEditor
        test={test}
        onChange={handleChange}
        data={value}
        config={config(props)}
        type={'classic'}
        ref={ref}
        readOnly={disabled}
        onBeforeLoad={(editor) => {
          editor.on('instanceReady', () => {
            onLoaded();
          });
        }}
      />
    </Box>
  );
});

BaseRichTextInput.defaultProps = {
  test: null,
  minHeight: 200,
  maxHeight: 400,
  disabled: false,
  onLoaded: noop,
};

BaseRichTextInput.propTypes = {
  minHeight: PropTypes.number.isRequired,
  maxHeight: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  test: PropTypes.string,
  onLoaded: PropTypes.func,
};

export default BaseRichTextInput;
